import React from 'react'

const TripContext=React.createContext()

export default TripContext